export const history = {
  title: 'History',
  subtitle: 'Everything you have logged, ready for checkups',
  filterLabel: 'Show only',
  filterAll: 'All',

  daySummary: {
    feeds: (n: number) => (n === 1 ? '1 feed' : `${n} feeds`),
    wet: (n: number) => (n === 1 ? '1 wet' : `${n} wet`),
    dirty: (n: number) => (n === 1 ? '1 dirty' : `${n} dirty`),
    pumped: (amount: string) => `${amount} pumped`,
    slept: (duration: string) => `${duration} of sleep`,
  },

  row: {
    breast: 'Breast',
    bottle: 'Bottle',
    sideDuration: (side: string, duration: string) => `${side} ${duration}`,
    diaperWet: 'Wet',
    diaperDirty: 'Dirty',
    diaperBoth: 'Wet and dirty',
    atBirthWeight: 'At birth weight',
    belowBirthWeight: (pct: number) => `${pct}% below birth weight`,
    aboveBirthWeight: (pct: number) => `${pct}% above birth weight`,
    sleepOngoing: 'Still asleep',
  },

  empty: {
    title: 'Nothing logged yet',
    body: 'Feeds, diapers, weights, pumping, and sleep you log on the Track tab will show up here, organized by day. It makes answering the questions at your baby\'s checkups easy.',
    cta: 'Go to Track',
    noMatches: 'Nothing in this category yet. Try another filter, or choose All.',
  },

  showEarlier: 'Show earlier days',
};
